import {
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
} from '@ksyos/design-system';
import { chain } from 'lodash';
import type { IServiceGroup } from '@common/interfaces';
import type { IService } from '../../interfaces/service';
import type { IServiceOrganizationSettings } from '../../interfaces/serviceOrganizationSettings';
import { translateKey } from '../../../translate';
import { NullableFormattedDate } from '../../elements/NullableFormattedDate';

export type GetInactiveServiceOrganizationSettingsResultItem = Pick<
    IServiceOrganizationSettings,
    'id' | 'startDate' | 'endDate'
> & {
    serviceGroups: Pick<IServiceGroup, 'name'>;
    services: Pick<IService, 'name'>;
};

interface IOrganizationInactiveServiceOrganizationSettingsProps {
    inactiveServiceOrganizationSettings: GetInactiveServiceOrganizationSettingsResultItem[];
}

export function OrganizationInactiveServiceOrganizationSettings(
    props: IOrganizationInactiveServiceOrganizationSettingsProps
) {
    return (
        <>
            {chain(props.inactiveServiceOrganizationSettings)
                .groupBy((i) => i.serviceGroups.name)
                .map((serviceOrganizationSettings, serviceGroupName) => (
                    <Card key={serviceGroupName}>
                        <Card.Header title={serviceGroupName} />
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableHeader>{translateKey('service.service')}</TableHeader>
                                        <TableHeader>{translateKey('common.startingDate')}</TableHeader>
                                        <TableHeader>{translateKey('common.endDate')}</TableHeader>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {serviceOrganizationSettings.map((serviceOrganizationSetting) => {
                                        return (
                                            <TableRow key={serviceOrganizationSetting.id}>
                                                <TableCell>{serviceOrganizationSetting.services.name}</TableCell>
                                                <TableCell>
                                                    <NullableFormattedDate
                                                        value={serviceOrganizationSetting.startDate}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <NullableFormattedDate value={serviceOrganizationSetting.endDate} />
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Card>
                ))
                .value()}
        </>
    );
}
